import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=570b4e09"
import script from "./EmailModal.vue?vue&type=script&lang=ts"
export * from "./EmailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports